import { render, staticRenderFns } from "./ProjectContact.vue?vue&type=template&id=1ad418c0&"
import script from "./ProjectContact.vue?vue&type=script&lang=js&"
export * from "./ProjectContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports